import React from 'react'

import { useQueryParams } from 'raviger'
import CreateUserForm from './Forms/Create'
import UserTable from './Table'
import User from './User'

export default () => {
  const [{ id }] = useQueryParams()

  return id ? (
    <User />
  ) : (
    <>
      <CreateUserForm />
      <UserTable />
    </>
  )
}
